import React from 'react';
import { minutesToTimeString } from '../../../../../utils';
import './CompactEntry.css';
import CompactEntryButton from './CompactEntryButton/CompactEntryButton';

const CompactEntry = props => {
  const { data } = props;
  let content = null;

  // set content
  if (data.time !== undefined) {
    // normal
    const btnsTop = data.timeline.top.map(bTop => (
      <CompactEntryButton
        key={bTop.video}
        special={false}
        data={bTop}
        mapData={data.map}
      />
    ));
    const btnsBtm = data.timeline.bottom.map(bBtm => (
      <CompactEntryButton
        key={bBtm.video}
        special={false}
        data={bBtm}
        mapData={data.map}
      />
    ));
    content = (
      <React.Fragment>
        <div className="entry-time">{minutesToTimeString(data.time)}</div>
        <div>
          {btnsTop}
          {btnsBtm}
        </div>
      </React.Fragment>
    );
  } else {
    // special
    content = <CompactEntryButton special section={data.section} />;
  }

  return <div className="compact-entry">{content}</div>;
};

export default CompactEntry;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/SceneCompact/CompactEntry/CompactEntry.js